import React from "react";
import ReactDOM from "react-dom";

export function useSaveSearchDialog() {
    const [state, setState] = React.useState(null);

    const open = React.useCallback(({ defaultName }) => {
        return new Promise((resolve) => {
            setState({
                defaultName: defaultName || "",
                resolve,
            });
        });
    }, []);

    const onClose = React.useCallback(() => {
        state?.resolve(null);
        setState(null);
    }, [state]);

    const onSubmit = React.useCallback((e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const name = form.elements["ss-name"].value.trim();
        const shared = form.elements["ss-shared"].checked;
        state?.resolve({ name, shared });
        setState(null);
    }, [state]);

    const portal = state
        ? ReactDOM.createPortal(
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                <div className="bg-white rounded-xl shadow-xl w-[420px] max-w-[90vw]">
                    <form onSubmit={onSubmit}>
                        <div className="px-4 py-3 border-b">
                            <div className="text-[15px] font-semibold">Save search</div>
                        </div>
                        <div className="px-4 py-3 space-y-3">
                            <label className="block text-sm font-medium text-gray-700">
                                Name
                                <input
                                    name="ss-name"
                                    defaultValue={state.defaultName}
                                    required
                                    className="mt-1 w-full border rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-[var(--rusty-orange)]"
                                    placeholder="e.g. Vendor Category: Market Data Vendors"
                                />
                            </label>

                            <label className="inline-flex items-center gap-2">
                                <input type="checkbox" name="ss-shared" className="w-4 h-4" />
                                <span className="text-sm text-gray-800">Shared (visible to team)</span>
                            </label>
                        </div>
                        <div className="px-4 py-3 border-t flex justify-end gap-2">
                            <button type="button" onClick={onClose}
                                    className="px-3 py-1.5 rounded border text-gray-600 hover:bg-gray-50">Cancel</button>
                            <button type="submit"
                                    className="px-3 py-1.5 rounded border border-[var(--rusty-orange)] text-[var(--rusty-orange)] hover:bg-[var(--rusty-orange)]/10">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>,
            document.body
        )
        : null;

    return { openSaveDialog: open, saveDialogPortal: portal };
}
